import axios, {
  type AxiosResponse,
  type InternalAxiosRequestConfig,
  AxiosError
} from 'axios';
// import snakecaseKeys from 'snakecase-keys';
// import camelcaseKeys from 'camelcase-keys';
// import { ROUTES } from "@/src/constants";

const api = axios.create({
  // baseURL: process.env.NEXT_PUBLIC_BACKEND_URL,
  baseURL: import.meta.env.VITE_BACKEND_URL,
  timeout: 6000,
});

api.interceptors.request.use(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (config: InternalAxiosRequestConfig<any>) => {
    const token = localStorage.getItem('token');
    if (token && config.headers) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    // if (config.data && typeof config.data === 'object') {
    //   config.data = snakecaseKeys(config.data, { deep: true });
    // }

    // if (config.params && typeof config.params === 'object') {
    //   config.params = snakecaseKeys(config.params, { deep: true });
    // }

    return config;
  },
  (error: AxiosError): Promise<AxiosError> => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response: AxiosResponse): AxiosResponse => {
    // if (response.data && typeof response.data === 'object') {
    //   response.data = camelcaseKeys(response.data, { deep: true });
    // }
    return response;
  },
  (error: AxiosError): Promise<never> => {
    if (error.response?.status === 401) {
      console.error('Token expired or invalid. Logging out...');
      localStorage.removeItem('token');
      localStorage.removeItem('refresh_token');
      // window.location.href = ROUTES.LOGIN;
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
